import React from 'react'
import { getImage } from "../assets/images"
import { Link } from 'react-router-dom'
import AddToInterestButton from './AddToInterestButton'
import { generateProductUrl } from '../utils/slugify'


export const Product = (props) => {
    const { id, name, image, description, category } = props.data
    
    // Obter a imagem correta usando o sistema de imagens
    const productImage = getImage(image);
    
    // Gerar URL amigável para SEO
    const productUrl = generateProductUrl({
        id,
        name,
        category,
        code: id // usando ID como código do produto
    });
    
    return (
        <div className="produto-card">
            <div className="produto-image-container">
                <Link to={productUrl} className="produto-link">
                    {productImage ? (
                        <img src={productImage} alt={name} className="produto-imagem" />
                    ) : (
                        <div className="produto-imagem produto-no-image">
                            <span>Sem imagem</span>
                        </div>
                    )}
                </Link>
            </div>
            <Link to={productUrl} className="produto-link">
                <h2 className="produto-nome">{name}</h2>
                <p className="produto-descricao">{description}</p>
            </Link>
            {/* <span className="produto-preco">{price.toFixed(2).replace('.', ',')} €</span> */}
            <AddToInterestButton 
                productId={id}
                className="product-card"
                size="medium"
                showText={true}
            />
        </div>
    )
}
